import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(true);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setIsDarkMode(savedTheme === 'dark');
      document.documentElement.setAttribute('data-theme', savedTheme);
    } else {
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleNavLinkClick = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    if (window.innerWidth <= 768) {
      setIsOpen(false);
    }
  };

  const toggleTheme = () => {
    const newTheme = isDarkMode ? 'light' : 'dark';
    setIsDarkMode(!isDarkMode);
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container navbar-container">
        <Link to="/" className="logo">
          Anshul<span>Thakur</span>
        </Link>

        <div className="nav-right">
          <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
            <li><a href="/#about" onClick={(e) => handleNavLinkClick(e, 'about')}>About</a></li>
            <li><a href="/#evolution" onClick={(e) => handleNavLinkClick(e, 'evolution')}>Evolution</a></li>
            <li><a href="/#experience" onClick={(e) => handleNavLinkClick(e, 'experience')}>Experience</a></li>
            <li><a href="/#contact" onClick={(e) => handleNavLinkClick(e, 'contact')}>Contact</a></li>
            <li className="nav-theme-mobile">
              <button className="theme-toggle-nav" onClick={toggleTheme} aria-label="Toggle theme">
                <i className={`fas ${isDarkMode ? 'fa-moon' : 'fa-sun'}`}></i>
                <span>{isDarkMode ? 'Dark Mode' : 'Light Mode'}</span>
              </button>
            </li>
          </ul>

          <button
            className="theme-toggle-btn"
            onClick={toggleTheme}
            aria-label="Toggle theme"
            title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            <div className="theme-toggle-track">
              <i className="fas fa-sun theme-icon-sun"></i>
              <i className="fas fa-moon theme-icon-moon"></i>
              <div className={`theme-toggle-thumb ${isDarkMode ? 'light' : ''}`}></div>
            </div>
          </button>

          <div className={`menu-toggle ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
